import React from 'react';

const Portfolio = () => {
  const projects = [
    {
      id: 1,
      title: "BullBearly.com",
      description: "An AI-powered stock analysis application that leverages OpenAI technology to provide real-time market insights and comprehensive stock evaluations. Features intelligent data aggregation, predictive analytics, and actionable investment recommendations.",
      technologies: ["React", "Node.js", "OpenAI", "API Integration"],
      image: "https://via.placeholder.com/400x250/667eea/ffffff?text=BullBearly",
      link: "https://bullbearly.com",
      category: "website"
    },
    {
      id: 2,
      title: "TheGunClassifieds.com",
      description: "A comprehensive marketplace and product review platform for firearm enthusiasts. Features classified listings, detailed product reviews, user authentication, and advanced search capabilities for buying, selling, and researching firearms and accessories.",
      technologies: ["React", "Node.js", "Vite", "MongoDB"],
      image: "https://via.placeholder.com/400x250/764ba2/ffffff?text=The+Gun+Classifieds",
      link: "https://thegunclassifieds.com",
      category: "website"
    },
    {
      id: 3,
      title: "AffiReview.App",
      description: "Affiliate marketing platform which uses AI to generate content, articles and niche reviews for customers using affiliate links.",
      technologies: ["React", "Node.js", "AI Integration", "Affiliate Marketing"],
      image: "https://via.placeholder.com/400x250/4facfe/ffffff?text=AffiReview.App",
      link: "#",
      category: "website"
    },
    {
      id: 4,
      title: "ByLawIQ.app",
      description: "AI-powered HOA accountability platform that helps attorneys and homeowners build and manage HOA dispute cases. Users upload documents and paste emails; the system extracts key details (dates, amounts, deadlines, document types), builds a case timeline, and flags possible violations and procedural issues. ByLawIQ turns scattered HOA paperwork into organized, evidence-ready matter files so users can \"fight back with data.\"",
      technologies: ["AI", "Document Processing", "Case Management", "Legal Tech"],
      image: "https://via.placeholder.com/400x250/2d3748/ffffff?text=ByLawIQ.app",
      link: "https://bylawiq.app",
      category: "website"
    }
  ];

  return (
    <section id="portfolio" className="portfolio">
      <div className="container">
        <div className="section-header">
          <h2>Portfolio</h2>
          <p>Explore my latest projects and creative solutions</p>
        </div>
        
        <div className="portfolio-grid">
          {projects.map((project) => (
            <div key={project.id} className="portfolio-item">
              <div className="portfolio-image">
                <img src={project.image} alt={project.title} />
                <div className="portfolio-overlay">
                  <div className="portfolio-links">
                    <a href={project.link} className="portfolio-link">
                      <i className="fas fa-external-link-alt"></i>
                    </a>
                    <a href={project.link} className="portfolio-link">
                      <i className="fas fa-eye"></i>
                    </a>
                  </div>
                </div>
                <div className="portfolio-category">
                  {project.category === 'website' ? (
                    <i className="fas fa-globe"></i>
                  ) : (
                    <i className="fas fa-mobile-alt"></i>
                  )}
                  {project.category}
                </div>
              </div>
              <div className="portfolio-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="portfolio-technologies">
                  {project.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
